/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useRef, useState } from "react";

import styled from "styled-components";

import { Plate } from "src/classes/plate/Plate";
import { Shared as ShareIcon } from "src/components/UI/Icons";
import { Tooltip } from "src/components/UI/Tooltip";

import { ShareMenu } from "./ShareMenu";

interface Props {
  plate: Plate;
}

export const ShareButton = ({ plate }: Props) => {
  const buttonRef = useRef<HTMLDivElement>(null);

  const editors = plate.editors;
  const editable = plate.observe((state) => state.editable);

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <ShareButtonContainer ref={buttonRef}>
      {editable && editors.length > 0 && (
        <Tooltip
          tooltipText={`${editors[0].snapshot.username} ${
            editors.length > 1 ? `and ${editors.length - 1} other${editors.length - 1 > 1 ? "s" : ""} ` : ""
          } can edit`}
        >
          <ShareIcon style={{ marginRight: "10px" }} />
        </Tooltip>
      )}
      <TopbarTextButton onClick={() => setMenuOpen(!menuOpen)} id="cy-share-button">
        SHARE
      </TopbarTextButton>
      {menuOpen && <ShareMenu plate={plate} close={() => setMenuOpen(false)} ref={buttonRef} />}
    </ShareButtonContainer>
  );
};

const ShareButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const TopbarTextButton = styled.div`
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
  margin-right: 15px;
  &:hover {
    text-decoration: underline;
  }
`;
